import * as PropTypes from "prop-types";
import * as React from "react";

import { FilterUpdateCallback, QueryFunction } from "src/typing";

import Result from "src/models/result";
import ResultsGrid from "./ResultsGrid";

import {
  Checkbox,
  FormControlLabel,
  Paper,
  Typography
} from "@material-ui/core";

import Divider from "@material-ui/core/Divider";

import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";

const titleCase = (str: string): string =>
  str
    .toLowerCase()
    .split(" ")
    .map((word: string) => word.replace(word[0], word[0].toUpperCase()))
    .join(" ");

const styles = (theme: Theme) => ({
  currentPage: {
    color: "green",
    marginLeft: "1em",
    marginRight: "1em"
  },
  pageContainer: {
    marginTop: "2em",
    maxWidth: "100%"
  },
  pageItem: {
    marginLeft: "1em",
    marginRight: "1em"
  },

  dashboardBox: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "5%",
    marginRight: "5%",
    marginTop: "5%",
    maxWidth: "100%",
    width: "100%"
  },
  facetBox: {
    flexBasis: "25%",
    height: "50%",
    maxHeight: "50%"
  },
  resultBox: {
    flexBasis: "75%",
    maxWidth: "75%",
    paddingLeft: "10%",
    paddingRight: "10%",
    width: "75%"
  }
});

export interface IState {
  count: number;
  results: Result[];
  total: number;
}

export interface IProps extends WithStyles<typeof styles> {
  addFilter: FilterUpdateCallback;
  removeFilter: FilterUpdateCallback;

  count: number;
  facets: any;
  lastOffset: number;
  results: Result[];
  queryFn: QueryFunction;
  total: number;
}

class Dashboard extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      count: props.count,
      results: props.results,
      total: props.total
    };

    this.handleCheckbox = this.handleCheckbox.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }

  public componentWillReceiveProps(nextProps: IProps) {
    this.setState({
      count: nextProps.count,
      results: nextProps.results,
      total: nextProps.total
    });
  }

  public render() {
    const currentPage = this.props.lastOffset / 10;
    const pageCount = Math.ceil(this.state.total / 10);
    const { classes } = this.props;

    const spans = [];
    for (let i = 0; i < pageCount; i++) {
      const className =
        i === currentPage ? classes.currentPage : classes.pageItem;
      spans.push(
        <a
          onClick={this.handlePageClick}
          data-page={i}
          className={className}
          key={i}
        >
          {i + 1}
        </a>
      );
    }

    const facetNames = Object.keys(this.props.facets);

    const facets = facetNames.map((facetName, i) => {
      const facetValues = Object.keys(this.props.facets[facetName]);
      return (
        <div key={i}>
          <Typography>{titleCase(facetName)}</Typography>
          {facetValues.map((facetVal: any, j: number) => (
            <FormControlLabel
              key={j}
              control={
                <Checkbox
                  onChange={this.handleCheckbox}
                  value={"@" + facetName + "=" + facetVal}
                  color="primary"
                />
              }
              label={`${facetVal} (${this.props.facets[facetName][facetVal]})`}
            />
          ))}
          <Divider />
        </div>
      );
    });

    return (
      <div>
        <div className={classes.dashboardBox}>
          <Paper className={classes.facetBox}>{facets}</Paper>
          <div className={classes.resultBox}>
            <ResultsGrid results={this.state.results} />
            <Paper className={classes.pageContainer}>{spans}</Paper>
          </div>
        </div>
      </div>
    );
  }

  private handleCheckbox(e: React.ChangeEvent<HTMLInputElement>) {
    const splitted = e.target.value.split("=", 2);

    const facetName = splitted[0].slice(1);
    const facetValue = splitted[1];

    if (e.target.checked) {
      this.props.addFilter(facetName, facetValue);
    } else {
      this.props.removeFilter(facetName, facetValue);
    }
  }

  private handlePageClick(e: React.MouseEvent<HTMLElement>) {
    if (!e.currentTarget.dataset.page) {
      return;
    }

    const newOffset: number = parseInt(e.currentTarget.dataset.page, 10) * 10;
    this.props.queryFn(undefined, newOffset);
  }
}

(Dashboard as React.ComponentClass<IProps>).propTypes = {
  classes: PropTypes.object.isRequired
} as any;

export default withStyles(styles)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Dashboard.tsx